import { Injectable } from '@angular/core'
import { PageDetails } from '@ftr/contracts/api/core'
import { SearchRequest, SearchRequestType, SearchResponse } from '@ftr/contracts/api/search'
import { Uuid } from '@ftr/contracts/type/shared'
import { ApiResult } from '@ftr/foundation'
import { AppPaths } from '~app/app-routing.params'
import { ApiClient } from '~app/services/ftr-api/api-client'
import { ApiClientFactory } from '~app/services/ftr-api/api-client.factory'
import { CustomHttpParameterCodec } from '~app/util/custom-http-parameter-codec'
import { createAndAssign } from '~app/util/MappingUtils'
import { serializeHttpParams } from '~app/util/serializeHttpParams'

export const DEFAULT_SEARCH_PAGE_SIZE = 10

interface SearchOptions {
  query: string
  searchType: SearchRequestType
  pageNumber: number
  courtSystemId: Uuid
  resourceId?: Uuid
  pageSize?: number
}

@Injectable({
  providedIn: 'root',
})
export class SearchApiService {
  private readonly apiClient: ApiClient
  constructor(apiClientFactory: ApiClientFactory) {
    this.apiClient = apiClientFactory.build(AppPaths.Search)
  }

  searchRequest(searchOptions: SearchOptions): ApiResult<SearchResponse> {
    const { courtSystemId, query, pageNumber, resourceId, searchType } = searchOptions
    // Note: we are using this in lieu of adding moment-timezone or js-joda-timezones to our web bundle.
    const timeZoneId = Intl.DateTimeFormat().resolvedOptions().timeZone || ''
    return this.apiClient.get<SearchResponse>({
      params: serializeHttpParams(
        createAndAssign(SearchRequest, {
          courtSystemId,
          searchTerms: query as string,
          timeZoneId,
          page: new PageDetails(pageNumber, searchOptions.pageSize ?? DEFAULT_SEARCH_PAGE_SIZE),
          searchType,
          recordingId: searchType === SearchRequestType.ThisRecording ? resourceId : undefined,
          audioSegmentId: searchType === SearchRequestType.ThisAudioSegment ? resourceId : undefined,
        }),
      ),
      // using a custom encoder because timeZoneId could include a + which the default encoder treats as a space
      encoder: new CustomHttpParameterCodec(),
    })
  }
}
